import React from 'react';
import ReactDOM from 'react-dom/client';
import { FAQAllQuestionPage } from './FAQAllQuestionPage';
import { GroupedQuestion } from './IFAQAllQuestionPage';
import '~/styles/main.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

interface WindowWithData extends Window {
  data: GroupedQuestion;
}

const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <FAQAllQuestionPage categories={data.categories} />
  </React.StrictMode>
);
